import React from 'react'
import {Badge} from 'reactstrap'
import moment from 'moment'
import {Mutation} from 'react-apollo'
import {toast} from "react-toastify";
import removeProjectClientInvoiceMutation from "../../queries/server/mutations/remove_project_client_invoice";
import downloadProjectClientInvoiceMutation from "../../queries/server/mutations/download_project_client_invoice";
import LoadingButton from "./LoadingButton";
import removeProjectClientInvoiceLocalMutation from '../../queries/client_side/mutations/remove_project_client_invoice'
import removeProjectClientInvoiceCreditNoteLocalMutation from '../../queries/client_side/mutations/remove_project_client_invoice_credit_note'

const {format} = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
})

const ProjectInvoiceListItem = ({invoice, project_id, canDownload, canRemove, canEdit, onEdit, onAddCreditNote}) => {

    const amount = invoice.breakdown.reduce((carry, {amount}) => carry += amount, 0)

    return (
        <div className="d-flex flex-column border-bottom">
            <div className="d-flex flex-row justify-content-between align-items-center p-2">
                <div className="d-flex flex-column align-items-start justify-content-center">
                    <h7>{invoice.invoice_number} <Badge
                        color={invoice.paid_at ? 'success' : 'warning'}>{invoice.paid_at ? 'Paid' : 'Outstanding'}</Badge>
                    </h7>
                    <p className="font-weight-light p-0 m-0">{format(amount)}</p>
                    <small className="text-muted">Invoice
                        Date: {moment(invoice.created_at).format('DD/MM/YYYY')}</small>
                    <small className="text-muted">Issued
                        Date: {(invoice.issued_at) ? moment(invoice.issued_at).format('DD/MM/YYYY') : '-'}</small>
                    <small className="text-muted">Paid
                        Date: {(invoice.paid_at) ? moment(invoice.paid_at).format('DD/MM/YYYY') : '-'}</small>

                </div>

                <div className="d-flex flex-row align-items-start justify-content-around">

                    <LoadingButton
                        className="square-btn mr-2"
                        icon="edit"
                        loading={false}
                        size="sm"
                        color="warning"
                        forceDisabled={!canEdit}
                        onClick={() => {
                            if(onEdit) onEdit(invoice.id)
                        }}
                    />

                    <LoadingButton
                        className="square-btn mr-2"
                        size="sm"
                        icon="hand-holding-usd"
                        color="secondary"
                        forceDisabled={!canEdit}
                        onClick={() => {
                          if (onAddCreditNote) onAddCreditNote(invoice.id)
                        }}
                    />

                    <Mutation mutation={downloadProjectClientInvoiceMutation}>
                        {(downloadProjectClientInvoiceMutationFunc, {loading}) => (
                            <LoadingButton
                                className="square-btn mr-2"
                                size="sm"
                                icon="file-download"
                                loading={loading}
                                color="primary"
                                forceDisabled={!canDownload}
                                onClick={() => {
                                    downloadProjectClientInvoiceMutationFunc({variables: {url: invoice.invoice_url}})
                                        .then(({data}) => {
                                            const {downloadProjectClientInvoice} = data
                                            window.open(downloadProjectClientInvoice)
                                        })
                                }}
                            />
                        )}

                    </Mutation>
                    <Mutation mutation={removeProjectClientInvoiceLocalMutation}>
                        {(removeProjectClientInvoiceLocalMutationFunc) => (
                            <Mutation mutation={removeProjectClientInvoiceMutation}>
                                {(removeProjectClientInvoiceMutationFunc, {loading}) => (
                                    <LoadingButton
                                        className="square-btn"
                                        size="sm"
                                        icon="trash-alt"
                                        loading={loading}
                                        color="danger"
                                        forceDisabled={!canRemove}
                                        onClick={() => {
                                            removeProjectClientInvoiceMutationFunc({variables: {id: invoice.id}})
                                                .then(() => {
                                                    toast.success('Invoice Removed', {autoClose: 2000})
                                                    removeProjectClientInvoiceLocalMutationFunc({
                                                        variables: {
                                                            invoice_id: invoice.id,
                                                            project_id
                                                        }
                                                    })
                                                })
                                                .catch(e => toast.error(e.message, {autoClose: false}))
                                        }}
                                    />
                                )}

                            </Mutation>
                        )}

                    </Mutation>
                </div>
            </div>

            {
                invoice.hasOwnProperty('credit_notes') &&
                invoice.credit_notes.length > 0 &&
                invoice.credit_notes.map(credit_note => {

                    const cnAmount = credit_note.breakdown.reduce((carry, {amount}) => carry += amount, 0)

                    return (<div className="d-flex flex-row justify-content-between align-items-center border-bottom pl-3 pt-1 pb-2 pr-2 bg-light">
                        <div className="d-flex flex-column align-items-start justify-content-center">
                            <h7>{credit_note.invoice_number}
                            </h7>
                            <p className="font-weight-light p-0 m-0">{format(cnAmount)}</p>
                            <small className="text-muted">
                                Date: {moment(credit_note.created_at).format('DD/MM/YYYY')}</small>
                        </div>


                        <div className="d-flex flex-row align-items-start justify-content-around">



                            <Mutation mutation={downloadProjectClientInvoiceMutation}>
                                {(downloadProjectClientInvoiceMutationFunc, {loading}) => (
                                    <LoadingButton
                                        className="square-btn mr-2"
                                        size="sm"
                                        icon="file-download"
                                        loading={loading}
                                        color="primary"
                                        forceDisabled={!canDownload}
                                        onClick={() => {
                                            downloadProjectClientInvoiceMutationFunc({variables: {url: credit_note.invoice_url}})
                                                .then(({data}) => {
                                                    const {downloadProjectClientInvoice} = data
                                                    window.open(downloadProjectClientInvoice)
                                                })
                                        }}
                                    />
                                )}

                            </Mutation>
                            <Mutation mutation={removeProjectClientInvoiceCreditNoteLocalMutation}>
                                {(removeProjectClientInvoiceCreditNoteLocalMutationFunc) => (
                                    <Mutation mutation={removeProjectClientInvoiceMutation}>
                                        {(removeProjectClientInvoiceMutationFunc, {loading}) => (
                                            <LoadingButton
                                                className="square-btn"
                                                size="sm"
                                                icon="trash-alt"
                                                loading={loading}
                                                forceDisabled={!canRemove}
                                                color="danger"
                                                onClick={() => {
                                                    removeProjectClientInvoiceMutationFunc({variables: {id: credit_note.id}})
                                                        .then(() => {
                                                            toast.success('Credit Note Removed', {autoClose: 2000})
                                                            removeProjectClientInvoiceCreditNoteLocalMutationFunc({
                                                                variables: {
                                                                    invoice_id: invoice.id,
                                                                    credit_note_id: credit_note.id,
                                                                    project_id
                                                                }
                                                            })
                                                        })
                                                        .catch(e => toast.error(e.message, {autoClose: false}))
                                                }}
                                            />
                                        )}

                                    </Mutation>
                                )}

                            </Mutation>
                        </div>
                    </div>)
                })
            }
        </div>
    )

}

export default ProjectInvoiceListItem